import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addInventoryUseCase } from '../../../../usecases/InventoryUseCases/addInventoryUseCase';
import { Inventory } from '../../../../entities/Inventory';
import { inventoryApi } from "../../../api/inventoryApi"
import { fetchInventoriesUseCase } from '../../../../usecases/InventoryUseCases/fetchInventoriesUseCase';
import { notification } from 'antd';

const initialState = {
    inventories: [],
    searchQuery: "",
    loading: false,
    error: null,
    isInventoryAdded: false,
    draft: {
        inventories: null,
        bdfData: null
    },
    activeTab: null
};

const inventorySlice = createSlice({
    name: 'inventoriesList',
    initialState,
    reducers: {
        addInventoryPending(state) {
            state.loading = true;
            state.error = null;
        },
        addInventoryFulfilled(state, action) {
            state.loading = false;
            const newInventory = action.payload;
            const inventoryEntity = new Inventory(
                newInventory._id,
                newInventory.locations,
                newInventory.Illu,
                newInventory.width,
                newInventory.height,
                newInventory.CodeNo,
                newInventory.CASCode,
                newInventory.typeOfMedia,
                newInventory.img,
                newInventory.vendor,
                newInventory.ratePerMonth,
                newInventory.lat,
                newInventory.lng,
            );
            state.inventories.push(inventoryEntity);
            state.isInventoryAdded = true
        },
        addInventoryRejected(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        resetIsInventoryAdded(state) {
            state.isInventoryAdded = false;
        },
        fetchInventoriesPending(state) {
            state.loading = true;
            state.error = null;
        },
        fetchInventoriesFullfilled(state, action) {
            state.loading = false;
            state.inventories = action.payload;
        },
        fetchInventoriesRejected(state, action) {
            state.loading = false;
            state.error = action.payload;
        },
        searchQuery(state, action) {
            state.searchQuery = action.payload;
        },
        emptySearch(state, action) {
            state.searchQuery = "";
        },
        saveDraft(state, action) {
            state.draft = {
                inventories: action.payload.inventories,
                bdfData: action.payload.bdfData,
            }
        },
        emptyDraft(state) {
            state.draft = {
                inventories: null,
                bdfData: null
            }
        },
        setSideTab(state, action) {
            state.activeTab = action.payload
        }
    },
});

// Export action creators
export const {
    addInventoryPending,
    addInventoryFulfilled,
    addInventoryRejected,
    resetIsInventoryAdded,
    fetchInventoriesFullfilled,
    fetchInventoriesPending,
    fetchInventoriesRejected,
    searchQuery,
    emptySearch,
    saveDraft,
    emptyDraft,
    setSideTab
} = inventorySlice.actions;

// Reducer
export default inventorySlice.reducer;

// Thunk action creator for adding inventory
export const addInventory = (inventoryData) => async (dispatch) => {
    try {
        dispatch(addInventoryPending());
        const newInventory = await addInventoryUseCase(inventoryApi, inventoryData);
        dispatch(addInventoryFulfilled(newInventory.actualInfoEntered));

    } catch (error) {
        notification.error({message:error.message})
        dispatch(addInventoryRejected(error.message));
    }
};

//Thunk action creator for getting inventories

export const getInventories = () => async (dispatch) => {
    try {
        dispatch(fetchInventoriesPending());
        const inventories = await fetchInventoriesUseCase(inventoryApi);
        dispatch(fetchInventoriesFullfilled(inventories));
    } catch (error) {
        dispatch(fetchInventoriesRejected(error.message));
    }
}
